export default {
    install(app, options) {
        app.config.globalProperties.$translated = function (value) {
            const translated = this.$t(value);
            return translated != value;
        };
    }
};
